
  class SocialShare extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        this.querySelectorAll('.btn-sharing').forEach(share => {
            share.addEventListener("click", event => {
              event.preventDefault();
              const target = event.currentTarget;
              const social = target.getAttribute('data-social');
              window.open(social);
            }, false);
        });
    }
  }
  customElements.define("social-share", SocialShare);
  

  (() => {
  const content = document.querySelector('.article-template__content');
  const tocRoot  = document.getElementById('blog-toc-root');
  if (!content || !tocRoot) return;

  // === Reglas pedidas ===
  const LEVELS = ['H2','H3'];   // solo H2 y H3
  const MIN_HEADINGS = 4;       // mínimo para mostrar TOC

  // 1) Obtener solo H2/H3 con texto
  const headings = Array.from(content.querySelectorAll(LEVELS.join(',')))
    .filter(h => h.textContent.trim().length);

  if (headings.length < MIN_HEADINGS) return;

  // 2) Crear IDs únicos (slug)
  const idCount = Object.create(null);
  const slugify = (s) => s.trim().toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^a-z0-9\s-]/g,'')
    .replace(/\s+/g,'-')
    .replace(/-+/g,'-');
  const uniqueId = (base) => {
    idCount[base] = (idCount[base] || 0) + 1;
    return idCount[base] === 1 ? base : `${base}-${idCount[base]}`;
  };

  // 3) Construir lista con numeración 1, 2, 2.1, 2.2…
  const list = tocRoot.querySelector('.gy-toc__list');
  let h2Index = 0;
  let h3Index = 0;
  let currentH2Li = null;
  let currentSubOl = null;

  headings.forEach(h => {
    if (!h.id) h.id = uniqueId(slugify(h.textContent) || 'section');

    if (h.tagName === 'H2') {
      h2Index += 1;
      h3Index = 0;

      const li = document.createElement('li');
      li.dataset.level = '2';

      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = `${h2Index}. ${h.textContent}`;

      li.appendChild(a);
      list.appendChild(li);

      // preparar sublista para posibles H3
      currentH2Li = li;
      currentSubOl = null;

    } else if (h.tagName === 'H3') {
      if (!currentH2Li) return; // si aparece H3 sin H2 previo, ignora

      h3Index += 1;
      if (!currentSubOl) {
        currentSubOl = document.createElement('ol');
        currentH2Li.appendChild(currentSubOl);
      }

      const li = document.createElement('li');
      li.dataset.level = '3';

      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = `${h2Index}.${h3Index} ${h.textContent}`;

      li.appendChild(a);
      currentSubOl.appendChild(li);
    }
  });

  // 4) Insertar la TOC justo antes del primer titular (H2/H3)
  const firstHeading = content.querySelector(LEVELS.join(','));
  if (firstHeading) firstHeading.before(tocRoot);

  // 5) Mostrar y dejarla abierta por defecto
  tocRoot.hidden = false;
  const details = tocRoot.querySelector('details');
  if (details) details.open = true; // abierto por defecto
})();


/* ===== RGPD comentarios blog (Garmonyarns) ===== */
(function () {
  function initCommentRGPD(form) {
    if (!form || form.dataset.gyRgpdInit === 'true') return;
    form.dataset.gyRgpdInit = 'true';

    var submitBtn = form.querySelector('input[type="submit"]');
    var honeypot = form.querySelector('input[name="gy_hp"]'); // está dentro del form

    function updateSubmitState() {
      if (!submitBtn) return;
      submitBtn.disabled = !!(honeypot && honeypot.checked);
    }

    if (honeypot) {
      honeypot.addEventListener('change', updateSubmitState);
      updateSubmitState(); // por si algún bot lo marcó antes de JS
    }

    form.addEventListener('submit', function (e) {
      if (honeypot && honeypot.checked) {
        e.preventDefault(); // bloquea envío si el honeypot está marcado
      }
      // El checkbox de privacidad usa "required": el navegador valida solo.
    });
  }

  function initAll() {
    document
      .querySelectorAll('form[id^="ArticleCommentForm-"]')
      .forEach(initCommentRGPD);
  }

  // Carga inicial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Soporte para el Editor de temas (cuando recarga secciones)
  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt.target) return;
    evt.target
      .querySelectorAll('form[id^="ArticleCommentForm-"]')
      .forEach(initCommentRGPD);
  });
})();
